import { Button } from "@msuite/ui/button";
import { Icon, icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Menu } from "@msuite/ui/menu";
import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { UserOverviewMeasurement } from "@msuite/utils/types";
import { useNavigate } from "react-router";
import { useHiddenProjectTabs } from "@/hooks/use-project-tabs";
import { projectTabPath } from "@/sites/projects/project/tabs";
import { useMeasurementsContext } from "./context";

export function RowActions({ cell }: CellContext<UserOverviewMeasurement, "actions">) {
	/** Hooks */
	const { t } = useTranslation();
	const navigate = useNavigate();
	const context = useMeasurementsContext();
	const hiddenTabs = useHiddenProjectTabs();

	/** Computed */
	const projectId = cell.row.original.id;
	const measurementListPath = projectTabPath(projectId, "measurements", hiddenTabs);

	/**	Functions */
	function handleOnNavigateToProject() {
		navigate(`/projects/${projectId}`);
	}

	function handleOnNavigateToMeasurementList() {
		navigate(measurementListPath);
	}

	/** Render */
	return (
		<RowActionsWrapper
			to={
				context.type === "manager"
					? measurementListPath
					: `/controlling/measurements/${context.userId}/${projectId}`
			}
		>
			<Menu
				items={() => [
					{
						label: t("projects.open_project"),
						icon: icon("Info"),
						onClick: handleOnNavigateToProject,
						cyId: "row-actions-open-button",
					},
					{
						label: t("measurements.open_measurement_list"),
						icon: icon("List"),
						onClick: handleOnNavigateToMeasurementList,
						cyId: "row-actions-open-measurement-list-button",
					},
				]}
			>
				<Button
					size="xxs"
					icon={<Icon name="EllipsisVertical" />}
					variant="ghost"
					data-cy="row-actions-button"
				/>
			</Menu>
		</RowActionsWrapper>
	);
}
